import { render, staticRenderFns } from "./IssuesPerStatus.vue?vue&type=template&id=098b9246"
import script from "./IssuesPerStatus.vue?vue&type=script&lang=js"
export * from "./IssuesPerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports